var map = {
	"./ar.json": 13933,
	"./ch.json": 35305,
	"./en.json": 82007,
	"./fr.json": 46863,
	"./gr.json": 77546,
	"./it.json": 35866,
	"./ru.json": 52182,
	"./sp.json": 40287
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63791;